// extracted by mini-css-extract-plugin
export default {"FAQ_page_section":"FAQ_FAQ_page_section__xu83m","content_flex":"FAQ_content_flex__1W6DU","left":"FAQ_left__64OQK","select_wrap":"FAQ_select_wrap__Tc6CR","right":"FAQ_right__q32zM"};